import { render, staticRenderFns } from "./CitationForm.vue?vue&type=template&id=722ef6ff"
import script from "./CitationForm.vue?vue&type=script&lang=ts"
export * from "./CitationForm.vue?vue&type=script&lang=ts"
import style0 from "./CitationForm.vue?vue&type=style&index=0&id=722ef6ff&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports